/**
 * Environment configuration for monitoring dashboard
 */

interface RequiredEnvVars {
  VITE_SUPABASE_URL: string
  VITE_SUPABASE_ANON_KEY: string
  VITE_API_URL: string
}

interface OptionalEnvVars {
  VITE_APP_URL?: string
  VITE_MONITORING_TOKEN?: string
  VITE_SENTRY_DSN?: string
  VITE_GIT_COMMIT_SHA?: string
}

function validateEnv(): RequiredEnvVars & OptionalEnvVars {
  const required = {
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
    VITE_API_URL: import.meta.env.VITE_API_URL,
  }

  const optional: OptionalEnvVars = {
    VITE_APP_URL: import.meta.env["VITE_APP_URL"] || undefined,
    VITE_MONITORING_TOKEN: import.meta.env["VITE_MONITORING_TOKEN"] || undefined,
    VITE_SENTRY_DSN: import.meta.env["VITE_SENTRY_DSN"] || undefined,
    VITE_GIT_COMMIT_SHA: import.meta.env["VITE_GIT_COMMIT_SHA"] || undefined,
  }

  const missing: string[] = []
  for (const [key, value] of Object.entries(required)) {
    if (!value || value === "undefined") {
      missing.push(key)
    }
  }

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(", ")}. ` +
        "Please ensure these are set during build time.",
    )
  }

  return { ...required, ...optional }
}

export const env = validateEnv()

console.log("Monitoring dashboard environment:", {
  supabaseUrl: env.VITE_SUPABASE_URL,
  apiUrl: env.VITE_API_URL,
  hasSentry: !!env.VITE_SENTRY_DSN,
  commit: env.VITE_GIT_COMMIT_SHA || "unknown",
})
